'use client';

import { sessionStorageHelper } from '@core/Utils/SessionStorageHelper';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { calculationAtom, resetCalculationAtom } from './Calculation.atom';
import { finCalcDataAtom } from './FinCalcData.atom';
import { resetSelectedProductIdAtom, selectedProductIdAtom } from './SelectedProductId.atom';

export const persistentFinCalcDataAtom = atomWithStorage<Record<string, any>>(
  'fin-calc-data',
  { isLoading: true },
  sessionStorageHelper as any,
);

export const persistentSelectedProductIdAtom = atomWithStorage<string | undefined>(
  'selected-product-id',
  undefined,
  sessionStorageHelper as any,
);

export const syncPersistedCalculatorStateAtom = atom(
  get => {
    return {
      finCalcData: get(persistentFinCalcDataAtom),
      selectedProductId: get(persistentSelectedProductIdAtom),
    };
  },
  (_get, set) => {
    let persistedFinCalcData = null;
    let persistedSelectedProductId = null;
    let persistedCalculation = null;

    if (typeof window !== 'undefined') {
      persistedFinCalcData = window.sessionStorage.getItem('fin-calc-data');
      persistedSelectedProductId = window.sessionStorage.getItem('selected-product-id');
      persistedCalculation = window.sessionStorage.getItem('calculation');
    }

    if (
      persistedFinCalcData &&
      typeof persistedFinCalcData === 'string' &&
      persistedFinCalcData !== '{}'
    ) {
      set(finCalcDataAtom, JSON.parse(persistedFinCalcData));
    }

    if (
      persistedSelectedProductId &&
      typeof persistedSelectedProductId === 'string' &&
      persistedSelectedProductId !== 'undefined'
    ) {
      set(selectedProductIdAtom, JSON.parse(persistedSelectedProductId));
    }

    if (
      persistedCalculation &&
      typeof persistedCalculation === 'string' &&
      persistedCalculation !== 'undefined' &&
      persistedCalculation !== 'null'
    ) {
      set(calculationAtom, JSON.parse(persistedCalculation));
    }
  },
);

export const saveCurrentCalculatorStateAtom = atom(null, (get, set) => {
  const currentFinCalcData = get(finCalcDataAtom);
  const currentSelectedProductId = get(selectedProductIdAtom);

  set(persistentFinCalcDataAtom, currentFinCalcData);
  set(persistentSelectedProductIdAtom, currentSelectedProductId);
});

export const resetPersistentCalculatorStateAtom = atom(null, (_get, set) => {
  set(persistentFinCalcDataAtom, { isLoading: true });
  set(persistentSelectedProductIdAtom, undefined);
  set(resetCalculationAtom);
  set(resetSelectedProductIdAtom);
});
